export function falsey(arg: any) {
  if (
    arg === false ||
    arg === 0 ||
    Object.is(arg, -0) ||
    arg === "" ||
    arg === null ||
    arg === undefined ||
    Number.isNaN(arg)
  ) {
    return true;
  }

  return false;
}
